<template>
    <div class="kgr-grid kgr-grid--gutters kgr-grid--inlineBlock" :class="{ 'animated fadeInLeft': animate }">
        <table class="kgr-table">
            <thead>
                <tr class="kgr-table__row">
                    <td
                        v-t="'Mitgliedschaften'"
                        colspan="3"
                        class="kgr-table__cell kgr-text--bold"
                    ></td>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="contract in memberContractHistory.contracts"
                    :key="contract.id"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        {{ $t(`memberShortProfile.contractType.${contract.type}`) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ contract.start.format('DD.MM.YYYY') }} - {{ contract.end ? contract.end.format('DD.MM.YYYY') : $t('offen') }}
                    </td>
                </tr>
                <tr v-if="memberContractHistory.contracts.length === 0">
                    <td
                        v-t="'Dieses Mitglied hat keine Verträge.'"
                        class="kgr-table__cell"
                    >
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import MemberContractHistory from '../../js/dto/MemberContractHistory';

export default {
    props: {
        memberContractHistory: {
            type: MemberContractHistory,
            required: true,
        },
        animate: {
            type: Boolean,
            required: false,
            default: true,
        },
        asIcon: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .kgr-table__cell {
    padding-top: 0;
    padding-bottom: 0;
}
table,
tr,
th,
td {
    margin-top: 0;
    margin-bottom: 0;
    border: none;
}
</style>
